import { Footer } from "@/components";
import styles from '@/assets/styles/root.module.scss';
import HeaderNoPermissonsV2 from "@/components/HeaderNoPermissonsV2/HeaderNoPermissonsV2";

export default function NoPermission() {
  return (
    <>
      <HeaderNoPermissonsV2 />
      <main>
        <figure className={styles.wrapper}>
          <img src="/no-permission.svg" alt="no-permission" />
          <figcaption className={styles.content}>
            <p className={styles.msg}>
              <span>Unfortunately, you don't have access to this service.</span>
              <span>Please contact administrator for assistance.</span>
            </p>
          </figcaption>
        </figure>        
      </main>
      <Footer />
    </>
  );
}